import InboxModule from "modules/inbox/inbox.module";
import React from "react";

const InboxPage = () => {
  return <InboxModule />;
};

export default InboxPage;
